import { call, put } from 'redux-saga/effects';
import CreateMakeUpSessionActions from '../redux/CreateMakeUpSessionRedux';
import { api } from './api';


export function* createmakeupsessionsagas(action: any): Generator<any, void, any> {
  const { children_id } = action;
  const response = yield call(api.createMakeUpSession, children_id);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(CreateMakeUpSessionActions.createMakeUpSessionSuccess(response.data));
  } else {
    yield put(CreateMakeUpSessionActions.createMakeUpSessionFailure());
  }
}